import DisbursementInformation from './DisbursementInformation.vue';

export default DisbursementInformation;
